import {
    SET_ROLES
} from '../actions/types';

const initialState = []

export function role(state = initialState, action = {}) {
    switch (action.type) {
        case SET_ROLES:
            return action.roles;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/role.js